export default __webpack_public_path__ + "static/media/Declaracion-juramentada-nivel-desempeÃ±o-museal-2025.c50d3611.docx";